export const mapFieldConfigInfoToSimpleFieldConfig = (fieldConfigInfo, defaultLabel) => {
	var simpleFieldConfig = {
		fieldLabel: fieldConfigInfo.fieldLabel || defaultLabel,
		isEnabled: (fieldConfigInfo.fieldBehaviorFlags & 1) ? true : false,
		isVisible: (fieldConfigInfo.fieldBehaviorFlags & 2) ? true : false,
		isEditable: (fieldConfigInfo.fieldBehaviorFlags & 4) ? true : false,
		isRequired: (fieldConfigInfo.fieldBehaviorFlags & 8) ? true : false,
	};
	return simpleFieldConfig;
}